/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PageType from 'linced-app/enums/page-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      learner: this.store.query('posts/page', {
        type: PageType.STUDENT,
        visibleInMenu: true,
      }),
      staff: this.store.query('posts/page', {
        type: PageType.STAFF,
        visibleInMenu: true,
      }),
      school: this.store.query('posts/page', {
        type: PageType.SCHOOL,
        visibleInMenu: true,
      }),
    });
  }
}
